
import { Action, Getter } from 'vuex-class'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { handleFill, moneyFormat } from '@/utils/util'
import { getStoreOrderDtlNew } from '@/api/industryMall'
Component.registerHooks(['beforeRouteLeave']);
@Component({
  name: 'mendianOrderlDetail',
  components: {
  },
})
export default class mendianOrderlDetail extends Vue {
  @Getter companyId!: string
  @Getter info!: any
  handleFill = handleFill
  moneyFormat = moneyFormat;

  // 订单信息对象
  orderInfo: any = {}
  orderId = ''
  orderStatus = ''

  created() {
    this.orderId = this.$route.query.orderId as string
    this.orderStatus = this.$route.query.orderStatus as string
  }

  mounted() {
    this.getInfo()
  }

  handleBack() {
    this.$router.back()
  }

  goGoodsDetail(item: any){
    // 无码商品不允许跳转， 后端固定返回 goodsId 9999999999999
    if (item.goodsId === '9999999999999') return
    this.$router.push({
      path: '/addGoods',
      query: {
        goodsId: item.goodsId,
        type: 'edit'
      }
    })
  }

  getInfo() {
    getStoreOrderDtlNew({
      orderId: this.orderId,
      storeId: this.companyId
    }).then((res) => {
      this.orderInfo = res.data
    })
  }
  
  getPayWay(type: number){
    switch (type) {
      case 0:
        return '现金'
      case 1:
        return '白条'
      case 2:
        return '微信'
      case 3:
        return '支付宝'
      case 4:
        return '储值卡'
      case 5:
        return '组合支付'
      case 6:
        return '收款码'
    }
  }

  beforeRouteLeave (to, from, next) {
    to.query.active = 0
    to.query.activeStatus = from.query.activeStatus
    next();
  }

}
